module.exports = __webpack_public_path__ + "img/nodata.3e426ece.png";